import {Form, Row, Col, Card, Select, notification, Input, Button} from 'antd';
import React, {useEffect, useState} from "react";
import jsonfile from './chartofaccount.json'
import {CisUI} from '../../../../util/CISUI'
import InputFields from '../../../../util/InputField'
import 'react-smart-data-table/dist/react-smart-data-table.css'
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {useHistory} from "react-router-dom";
import RemoteJson from "../../../../util/gerremotedata";
import $ from "jquery";
import SelectData from "../../../../util/selectdata";
import CircularProgress from "../../../../components/CircularProgress";

const { Option } = Select;

const EditChartOfAccounts = (props) => {
    const userID = props.match.params.id;
    const formRef = React.createRef();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const AccountsLevel = SelectData("accounts/accountslevel");
    const AllAccounts = SelectData("accounts/allaccountsbylevel");
    const AccountTypes = SelectData("accounts/accounttype");

    const [accounts, setAccounts] = useState([]);

    const [form] = Form.useForm();

    const history = useHistory();

    const handleChange=(e)=> {
        // setState({
        //     [e.target.id]: e.target.value
        // })
        console.log(e.target.value);
    }

    const getData = () => {
        setLoading(true)
        axios.get(jsonfile.urls.view + "/" + userID)
            .then( res =>{
                if(res.data.status === 1){
                    setData(res.data.data);
                }
                else{
                    CisUI().showAlert("Alert", "warning", res.data.msg);
                }
                setLoading(false);
            })
            .catch(errors => console.log(errors))
    }

    useEffect(() => {
        getData();
    }, [])



    // console.log("Userid : "+props.match.params.id);
    // let isEdit = 0;
    // if(userID > 0) {
    //     isEdit = 1;
    // }
    // let Title = jsonfile.addtitle;
    let endpoint = jsonfile.urls.edit+"/"+userID;
    let redirectto = "../../"+jsonfile.urls.list;
    // let userData = "";

    // if(isEdit === 1 ) {
    //     userData = RemoteJson(jsonfile.urls.view+"/"+userID);
    //
    //     Title = jsonfile.edittitle;
    //     endpoint = jsonfile.urls.edit+"/"+userID;
    //     redirectto = "../../"+jsonfile.urls.list;
    // }

    const onFinish = (values) => {
        //setLoading({loading:true})
        // console.log("Input Data : "+values);
        // let msg = "Sorry! request not processed, please try again";
        setLoading(true);
        axios.post(Config.apiserver + endpoint, values)
            .then(res => {
                // console.log(res)
                if(res.data.status === 1) {
                    CisUI().showAlert('Success', "success", res.data.msg);
                    history.push(redirectto);
                }
                else {
                    // notification.warning({
                    //     message: 'Alert',
                    //     type : "warning",
                    //     description: res.data.msg
                    // });
                    CisUI().showAlert('Alert', "warning", res.data.msg);
                }
                setLoading(false);
            })
            .catch(errors => {
                console.log(errors);
                // msg = (errors);
                setLoading(false);
                //setResponse([]);
            });
    };

    // $("#input_parent_account_number").change(function(){
    //     const vl = document.getElementById("#input_parent_account_number").value;
    //     console.log(vl);
    // });

    $('#input_parent_account_number').unbind('keyup');
    $('#input_parent_account_number').bind('keyup', function (e) {
        const parent = this.value;
        const level = formRef.current.getFieldValue("act_level");
        if(level === null) {
            notification.warning({
                message: 'Alert',
                type : "warning",
                description: "Please select a Account Level"
            });
        }

        if(parent.length === 5) {
            CisUI().LoadingOn();
        }

    });



    const onLevelChange = value => {
        setAccounts(AllAccounts[value]);
    };

    // $("#input_parent_account_number").keyup(function () {
    //     console.log(this.value);
    // });

    //console.log("UserData : "+userData);

    // const ParentAccount = (
    //     userData === "" ? <CircularProgress/> :
    //         (
    //             <>
    //
    //             </>
    //         )
    // )

    return (

        // userData === "" ? <CircularProgress /> :
        loading ? <CircularProgress /> :
            <Card title={jsonfile.edittitle} extra={CisUI().addAction('../../' + jsonfile.urls.list)}>
                <Form
                    form={form}
                    {...CisUI().formItemLayout}
                    name="input"
                    ref={formRef}
                    className="ant-advanced-search-form"
                    onFinish={onFinish}
                >

                    <Row gutter={24}>
                        {
                            CisUI().getUserInfo('area') >= 26 ? <></> :
                                <Col lg={12} md={12} sm={12} xs={24}>
                                    <div className="gx-form-row0">
                                        <Form.Item
                                            name="act_level"
                                            label="Access Level"
                                            initialValue={data?.act_level}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Select a level"
                                                },
                                            ]}
                                        >
                                            <Select
                                                showSearch
                                                placeholder="Select a level"
                                                optionFilterProp="children"
                                                onChange={onLevelChange}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                {
                                                    AccountsLevel?.map((items, index) =>
                                                        <Option key={++index} value={items.id}>{items.name}</Option>
                                                    )
                                                }
                                            </Select>
                                        </Form.Item>

                                    </div>
                                </Col>
                        }

                        <Col lg={12} md={12} sm={12} xs={24} id="parents">
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="parent_id"
                                    label="Parent Account Number (If it is subsidiary account)"
                                    initialValue={data.parent_id}
                                    rules={[
                                        {
                                            required: false,
                                            message: "Select a Parent Account"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a Parent Account"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            CisUI().getUserInfo('com_id') > 0 ?
                                                AllAccounts.map((items, index) =>
                                                    <Option key={++index} value={items.id} >{items.name}</Option>
                                                )
                                                :
                                                accounts.map((items, index) =>
                                                    <Option key={++index} value={items.id} >{items.name}</Option>
                                                )
                                        }
                                    </Select>
                                </Form.Item>

                            </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="act_type"
                                    label="Account Type"
                                    initialValue={data?.act_type}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Account Type is required"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a account type"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {
                                            AccountTypes.map((items, index) =>
                                                <Option key={++index} value={items.id} >{items.name}</Option>
                                            )
                                        }
                                    </Select>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="account_number"
                                    label="Account Number"
                                    initialValue={data?.account_number}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Account Number is required"
                                        },
                                    ]}
                                >
                                    <Input className="gx-w-100" placeholder="Account Number" />
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="account_name"
                                    label="Account Name"
                                    initialValue={data?.account_name}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Account Name is required"
                                        },
                                    ]}
                                >
                                    <Input className="gx-w-100" placeholder="Account Name" />
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="description"
                                    label="Description"
                                    initialValue={data?.description}
                                    rules={[
                                        {
                                            required: false,
                                            message: "Description is required"
                                        },
                                    ]}
                                >
                                    <Input className="gx-w-100" placeholder="Description" />
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={12} md={12} sm={12} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="status"
                                    label="Status"
                                    initialValue={data?.status}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Status is required"
                                        },
                                    ]}
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select a status"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        <Option value={1} >Active</Option>
                                        <Option value={0} >Inactive</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </Col>

                    </Row>

                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24} style={{textAlign: 'center', marginTop: '30px'}}>
                            <Button id="submitbutton" type="primary" htmlType="submit">
                                Save
                            </Button>
                            <Button type="info" onClick={() => history.goBack()}>Cancel</Button>
                        </Col>
                    </Row>

                </Form>
            </Card>

    );
};


export default EditChartOfAccounts;